export default "__VITE_ASSET__WOy2xtVP__"